import { useState, useEffect, useCallback } from "react";

const useCallApi = (call, options = {}) => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [reloadTrigger, setReloadTrigger] = useState(0);

    const reload = useCallback(() => {
        setReloadTrigger((prev) => prev + 1);
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                let response = null;
                if (Array.isArray(options)) {
                    response = await call(...options);
                } else {
                    response = await call(options)
                }
                setData(response);
                setLoading(false);
            } catch (error) {
                setError(error);
                setLoading(false);
            }
        };
        fetchData();
    }, [options, reloadTrigger, call]);

    return { data, loading, error, reload };
};

export default useCallApi;
